import React from 'react';
import {IconButton, Tooltip} from '@material-ui/core';
import {bindActionCreators} from 'redux';
import connect from 'react-redux/es/connect/connect';
import * as FilterActions from './Store/Actions/FilterActions';
import {MdSearch} from 'react-icons/md';

const PainelToggleButton = ({togglePainel}) => {
    return (
        <Tooltip
            title={"Pesquisar"}
        >
            <IconButton 
                onClick={togglePainel}
            >
                <MdSearch className="text-20 text-white"/>
            </IconButton>
        </Tooltip>
    );
};

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        togglePainel: FilterActions.togglePainel
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(PainelToggleButton);
